<template>
  <div class="schedule-edit-wrapper">
    <div class="edit-form">
      <div class="edit-item">
        <div class="edit-type required"><span>出诊机构/医院</span></div>
        <div class="edit-content">
          <input type="text" class="form-text" placeholder="请输入" v-model="hospital">
        </div>
      </div>
      <div class="edit-item">
        <div class="edit-type required"><span>出诊科室/房间</span></div>
        <div class="edit-content">
          <input type="text" class="form-text" placeholder="请输入" v-model="position">
        </div>
      </div>
      <div class="edit-item">
        <div class="edit-type required"><span>挂号费</span></div>
        <div class="edit-content ">
          <div class="fee-typer-box">
            <number-input class="fee-typer" placeholder="请输入金额" v-model="doc_fee" :min="0.00" />
            <span class="unit">元/次</span>
          </div>
        </div>
      </div>
      <div class="edit-item">
        <div class="edit-type required"><span>选择坐诊日期</span></div>
        <div class="edit-content">
          <div class="date-picker" @click="datePickerShow = true">
            <span class="placeholder" v-if="!scheduleDate">请选择坐诊日期</span>
            <span class="value" v-else>{{scheduleDate | dateFilter}}</span>
          </div>
        </div>
      </div>
      <div class="edit-item">
        <div class="edit-type required"><span>选择坐诊时间段</span></div>
        <div class="edit-content">
          <div class="time-picker" @click="pickStartTime">
            <span class="placeholder" v-if="!startTime">开始时间</span>
            <span class="value" v-else>{{startTime}}</span>
          </div>
          <div class="line"></div>
          <div class="time-picker" @click="pickEndTime">
            <span class="placeholder" v-if="!endTime">结束时间</span>
            <span class="value" v-else>{{endTime}}</span>
          </div>
        </div>
      </div>
      <div class="edit-item">
        <div class="edit-type required"><span>可就诊人数</span></div>
        <div class="edit-content">
          <div class="number-typer" @touchstart.stop="keyboardShow = true">
            <span class="placeholder" v-if="!patientNumber">请输入</span>
            <span class="value" v-else>{{patientNumber}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="submit-schedule"><button class="submit-button" :disabled="submitting" @click="submitSchedule">发布日程</button></div>

    <!-- 弹出层 -->
    <!-- 日期选择 -->
    <van-popup v-model="datePickerShow" position="bottom">
      <van-datetime-picker type="date" :min-date="minDate" :max-date="maxDate" @confirm="confirmDate" @cancel="datePickerShow = false" />
    </van-popup>
    <!-- 开始时间选择 -->
    <van-popup v-model="startTimePickerShow" position="bottom">
      <van-datetime-picker type="time" :filter="timeFilter" :min-hour="minStartTime" :min-minute="minStartMinute"
        @confirm="confirimStartTime" @cancel="startTimePickerShow = false" />
    </van-popup>
    <!-- 结束时间选择 -->
    <van-popup v-model="endTimePickerShow" position="bottom">
      <van-datetime-picker type="time" :filter="timeFilter" :min-hour="minEndTime" :min-minute="minEndMinute" @confirm="confirimEndTime"
        @cancel="endTimePickerShow = false" @change="endTimeChange" />
    </van-popup>
    <!-- 填写人数 -->
    <van-number-keyboard v-model="patientNumber" :show="keyboardShow" :maxlength="2" @blur="keyboardShow = false" />

    <!-- 弹窗 -->
    <!-- 时间冲突 -->
    <x-dialog v-if="scheduleError" title="发布诊疗日程" @close="scheduleError = false">
      <div class="error-wrapper">
        <div class="error-text">
          <div class="time">{{scheduleDate | dateFilter}} {{startTime}} - {{endTime}}</div>
          <p>已有相同时间段的日程发布</p>
        </div>
        <div class="error-control">
          <button class="back" @click="cancel">取消发布</button>
          <button class="cancel" @click="scheduleError = false">重新选择时间</button>
        </div>
      </div>
    </x-dialog>
  </div>
</template>

<style lang="less" scoped>
  .schedule-edit-wrapper{
    min-height: 100vh;
    background: #F7F7F7;
    padding-top: 12px;
    .edit-form{
      background: #FFF;
      padding: 24px 0 0;
      .edit-item{
        padding: 0 0 12px 20px;
        .fee-typer-box{
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #FFF;
          .label, .unit{
            flex-shrink: 0;
          }
          .fee-typer{
            flex: 1;
            padding: 8px 3px;
            font-size: 15px;
            line-height: 20px;
            color: #333;
          }
        }
        .edit-type{
          span{
            position: relative;
            font-size: 15px;
            line-height: 15px;
            color: #666;
            font-weight: bold;
            &::after{
              content: '*';
              position: absolute;
              left: 100%;
              top: 0;
              font-size: 14px;
              line-height: 14px;
              color: @error;
              margin-left: 2px;
              font-weight: bold;
            }
          }
        }
        .edit-content{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .form-text{
            width: 200px;
            border: 0;
            text-align: left;
            font-size: 16px;
            line-height: 40px;
            color: #666;
            padding-left: 1px;;
            background: transparent;
            &::-webkit-input-placeholder{
              color: #999;
            }
          }
          .date-picker, .time-picker, .number-typer{
            padding: 14px 0;
          }
          .date-picker, .number-typer{
            width: 100%;
          }
          .placeholder{
            font-size: 15px;
            line-height: 15px;
            // font-weight: bold;
            color: #999;
          }
          .value{
            font-size: 15px;
            line-height: 15px;
            // font-weight: bold;
            color: @black;
          }
          .line{
            margin: 0 16px;
            width: 20px;
            height: 1px;
            background: #CCC;
          }
        }
      }
    }
    .submit-schedule{
      margin: 36px auto 0;
      width: 220px;
      .submit-button{
        @button-base();
        width: 100%;
        height: 36px;
        font-size: 14px;
      }
    }
  }
  // 弹窗样式
  .error-wrapper{
    padding: 40px 0 32px;
    text-align: center;
    .error-text{
      font-weight: bold;
      .time{
        font-size: 18px;
        line-height: 18px;
        color: @error;
        margin-bottom: 8px;
      }
      p{
        font-size: 16px;
        line-height: 16px;
        color: @black;
      }
    }
    .error-control{
      margin-top: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      button{
        @button-base();
        height: 36px;
        font-size: 14px;
        &.back{
          background: #FFF;
          border: 1px solid #999;
          color: #999;
          width: 112px;
          margin-right: 15px;
        }
        &.cancel{
          width: 144px;
        }
      }
    }
  }
</style>

<script type="text/javascript">
  import xDialog from '@/components/Common/dialog'
  import numberInput from '@/components/Common/numberInput'
  export default {
    data() {
      return {
        isToday: false,
        scheduleDate: null,
        minDate: new Date(),
        datePickerShow: false,
        // 开始时间
        startTime: null,
        minStartTime: 0,
        minStartMinute: 0,
        startTimePickerShow: false,
        // 结束时间
        endTime: null,
        minEndTime: 1,
        minEndMinute: 0,
        endTimePickerShow: false,
        // 人数
        patientNumber: '',
        keyboardShow: false,
        // 时间冲突弹窗状态
        scheduleError: false,

        submitting: false,

        hospital: '',
        position: '',
        doc_fee: 0
      }
    },
    components: {
      xDialog,
      numberInput
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
      maxDate() {
        let nowDate = new Date();
        let year = nowDate.getFullYear() + 1;
        let month = nowDate.getMonth() + 1;
        let date = nowDate.getDate();
        return new Date(year, month, date);
      }
    },
    created() {
      this.getDocFee();
    },
    methods: {
      getDocFee() {
        this.$root.post('/getDocFee', {
          doc_id: this.userInfo.user_id,
        }).then(data => {
          console.log(data)
          if (data.status) {
            this.doc_fee = data.fee;
          }
        });
      },
      setToday() {
        const today = moment().format('YYYY-MM-DD');
        if (moment(this.scheduleDate).format('YYYY-MM-DD') == today) {
          this.isToday = true;
          this.minStartTime = moment().hour();
          this.minEndTime = moment().hour() + 1;
        } else {
          this.isToday = false;
          this.minStartTime = 0;
          this.minEndTime = 1;
        }
      },
      timeFilter(type, options) {
        if (type === 'minute') {
          return options.filter(option => option % 10 === 0)
        }
        return options;
      },
      pickStartTime() {
        this.setToday();
        if (this.isToday && moment().minute() >= 50) {
          this.minStartTime = moment().hour() + 1;
        }
        this.startTimePickerShow = true;
      },
      pickEndTime() {
        this.endTimePickerShow = true;
        if (this.startTime) {
          let halfHour = moment(this.startTime, 'HH:mm').minute() + 30;
          if (halfHour >= 60) {
            let leftTime = halfHour - 60;
            this.minEndTime = moment(this.startTime, 'HH:mm').hour() + 1;
            this.minEndMinute = parseInt(0 + leftTime);
          } else {
            this.minEndTime = moment(this.startTime, 'HH:mm').hour();
            this.minEndMinute = moment(this.startTime, 'HH:mm').minute() + 30;
          }
        }
      },
      endTimeChange(picker) {
        // 结束时间选择分钟变化
        let value = picker.getValues();
        if (parseInt(value[0]) == this.minEndTime) {
          if (this.startTime) {
            let halfHour = moment(this.startTime, 'HH:mm').minute() + 30;
            if (halfHour >= 60) {
              let leftTime = halfHour - 60;
              this.minEndMinute = parseInt(0 + leftTime);
            } else {
              this.minEndMinute = moment(this.startTime, 'HH:mm').minute() + 30;
            }
          }
          // this.minEndMinute = this.startTime ? moment(this.startTime, 'HH:mm').minute() : 0;
        } else {
          this.minEndMinute = 0
        }
      },
      // 确认选择日期
      confirmDate(value) {
        this.scheduleDate = value;
        // 如果为今天的话不能选择之前的时间段
        this.setToday();
        this.datePickerShow = false;
      },
      confirimStartTime(value) {
        const hour = moment(value, 'HH:mm');
        const now = moment();
        if (this.endTime) {
          if (hour.hour() > moment(this.endTime, 'HH:mm').hour()) {
            this.$notify('开始时间不能大于结束时间');
            return;
          }
          if (hour.hour() == moment(this.endTime, 'HH:mm').hour() && hour.minute() >= moment(this.endTime, 'HH:mm').minute()) {
            this.$notify('开始时间不能大于结束时间');
            return;
          }
        }
        if (this.isToday && hour.isBefore(now)) {
          this.$notify('不能选择早于现在的时间');
          return;
        }
        this.startTime = value;
        // 设置结束时间 至少一小时
        this.minEndTime = hour.hour() + 1;
        this.startTimePickerShow = false;
      },
      confirimEndTime(value) {
        console.log(value)
        this.endTime = value;
        this.endTimePickerShow = false;
      },
      // 提交日程
      submitSchedule() {
        if (!this.hospital) {
          this.$notify('请输入出诊医院');
          return;
        } else if (!this.position) {
          this.$notify('请输入出诊科室/房间');
          return;
        } else if (!this.scheduleDate) {
          this.$notify('请选择坐诊日期');
          return;
        } else if (!this.startTime) {
          this.$notify('请选择开始时间');
          return;
        } else if (!this.endTime) {
          this.$notify('请选择结束时间');
          return;
        } else if (parseInt(this.patientNumber) == 0 || !this.patientNumber) {
          this.$notify('请输入可就诊人数');
          return;
        } else if (this.doc_fee == 0) {
          this.$notify('请输入挂号费');
          return;
        }


        this.submitting = true;
        const dateString = moment(this.scheduleDate).format('YYYY-MM-DD');
        const startTimeStamp = moment(`${dateString} ${this.startTime}`, 'YYYY-MM-DD HH:mm').unix();
        const endTimeStamp = moment(`${dateString} ${this.endTime}`, 'YYYY-MM-DD HH:mm').unix();

        this.$root.post('/setOffline', {
          doc_id: this.userInfo.user_id,
          start_time: startTimeStamp,
          end_time: endTimeStamp,
          pat_limit: this.patientNumber,
          hospital:this.hospital,
          position:this.position,
          money:this.doc_fee
        }).then(data => {
          console.log(data);
          this.submitting = false;
          if (data.status == 1) {
            this.$notify({
              message: '诊疗日程发布成功',
              background: '#00848A'
            });
            setTimeout(() => {
              this.$router.go(-1);
            }, 1000);
          } else if (data.status == -1) {
            // status == -1 为有时间冲突，显示弹窗
            this.scheduleError = true;
          } else {
            this.$notify(data.msg);
          }
        })
      },
      // 取消日程
      cancel() {
        this.$router.go(-1);
      }
    },
    filters: {
      dateFilter(value) {
        return moment(value).format('MM月DD日');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/Schedule/offLineEdit.vue